// extracted by mini-css-extract-plugin
module.exports = {"modal":"InfoMessageModal_modal__3faJT","text":"InfoMessageModal_text__2g09J","buttons":"InfoMessageModal_buttons__3jr4E","btn":"InfoMessageModal_btn__2S6sH"};